var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-grid',{ref:"grid",attrs:{"url":"sms?broadcastID=","columns":_vm.columns,"title":_vm.title,"actions":_vm.actions,"mapper":_vm.mapResults,"sortOptions":{
            enabled: true,
            field: 'dateTime',
            type: 'desc',
        }}}),_c('v-dialog',{attrs:{"max-width":"800"},model:{value:(_vm.imageViewDialog),callback:function ($$v) {_vm.imageViewDialog=$$v},expression:"imageViewDialog"}},[_c('v-card',_vm._l((_vm.clickedRow.images),function(image){return _c('div',[_c('v-img',{attrs:{"src":image}})],1)}),0)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }